import React from 'react';

import styles from './tableStyles';

// Row heights: small = 20, medium (default) = 30, large = 40

const Table = ({
  headings,
  items,
  getItemMainAttr,
  getItemAttrs,
  entryClassName,
  noEntryClassName,
  rowHeight
}) => {
  const rowHeightClass = `
    ${rowHeight === 'small' && styles.smallRowHeight}
    ${rowHeight === 'large' && styles.largeRowHeight}
  `;
  const entryClasses = `${styles.tableEntry} ${entryClassName} ${rowHeightClass}`;
  const noEntryClasses = `
    ${styles.tableEntry}
    ${styles.tableNoEntry}
    ${rowHeightClass}
    ${noEntryClassName}
  `;
  return (
    <div className={styles.tableColumns}>
      {getItemMainAttr && (
        <div className={styles.tableMainAttrs}>
          <div className={styles.tableHeading} />
          {items.map((item, idx) => (
            <div key={idx} className={`${styles.tableEntry} ${rowHeightClass}`}>
              {getItemMainAttr(item)}
            </div>
          ))}
        </div>
      )}
      {headings.map((heading, columnNum) => (
        <div key={columnNum} className={styles.tableColumn}>
          <div className={styles.tableHeading}>{heading}</div>
          {items.map((item, rowNum) => {
            const attr = getItemAttrs(item)[columnNum];
            return (
              <div key={rowNum} className={attr ? entryClasses : noEntryClasses}>
                {attr || 'N/A'}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default Table;
